/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-events',
    'pip-model',
    'window'
],
function(
    pipEvents,
    pip,
    window
){

	function initEventListeners(){

		pipEvents.irg.irgLinkClicked.on('.irgLinkClicked', function(evtType, data){
      if (!data) return;
			var analyticsData = {
			  category: {
          primaryCategory: "stash"
        },
        eventInfo: {
          eventName: "recommendation pip load"
        },
        eventMode: "stash",
        stash: {
          recommendation: {
            recommendationType: data.apiName ? data.apiName : "irg",
            pageType: "pip",
            recommendationVersion: "n/a",
            featureVersion: data.tabsInteracted ? 'tab' : 'n/a',
            interval: "n/a",
            displayPosition: data.position,
            anchorProductSku: data.anchorProductSku,
            strategy: data.strategy === 'coordinatingitems' ? 'coordinating items' : data.strategy
          }
        }
			};
			if(pip.debugMode){
				window.location = data.href + window.location.search;
			} else {
				window.location = data.href;
			}
      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push(analyticsData);
      }
		});

        pipEvents.irg.singleItemAddToCart.on('.singleItemAddToCart', function(evtType, data) {
            if(!data) return;
            var analyticsData = {
                category: {
                    primaryCategory: "stash"
                },
                eventInfo: {
                    eventName: "recommendation cart addition"
                },
                eventMode: "stash",
                stash: {
                    target: "atc",
                    component: "product pod",
                    pageType: "pip",
                    section: "irg " + data.carouselName,
                    sharedSection: "n/a",
                    recommendation: {
                        recommendationType: "irg",
                        recommendationVersion: "n/a",
                        featureVersion: data.tabsInteracted ? 'tab' : 'n/a',
                        interval: "n/a",
                        pageType: "pip",
                        displayPosition: data.listPos,
                        anchorProductSku: pip.products.primary.data.itemId,
                        strategy: data.carouselName
                    },
                    item: [{
                        index: "n/a",
                        productID: data.item.itemId
                    }]
                }
            };

            if (window.digitalData && window.digitalData.event) {
                window.digitalData.event.push(analyticsData);
            }
        });

	}


	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));